import { render, staticRenderFns } from "./match_object.vue?vue&type=template&id=f0359f02&scoped=true"
import script from "./match_object.vue?vue&type=script&lang=js"
export * from "./match_object.vue?vue&type=script&lang=js"
import style0 from "./match_object.vue?vue&type=style&index=0&id=f0359f02&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0359f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0359f02')) {
      api.createRecord('f0359f02', component.options)
    } else {
      api.reload('f0359f02', component.options)
    }
    module.hot.accept("./match_object.vue?vue&type=template&id=f0359f02&scoped=true", function () {
      api.rerender('f0359f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/config_center/view/approval_config/form/components/match_object/match_object.vue"
export default component.exports